import { Button } from "@/3514/components"
import { type TUserState, useUser } from "@/3514/hooks"
import { THEME } from "@/3514/theme"
import { EUserRole } from "@/3514/types"
import { buildCssClassName } from "@/3514/utils"
import { useCalendarProfiles } from "@/entities/coach-calendar/api/use-calendar-profiles"
import { CoachCalendarStepUrls as CoachCalendarStep } from "@/pages/coach-settings/constants"
import AddIcon from "@/svgs/AddIconSvg"

import CalendarAccountItem from "./CalenarAccountItem"

import "./styles.scss"

type TProps = { isQueryEnabled: boolean; throwOnError: boolean; isRedesigned?: boolean }

export const CalendarAccounts = ({ isQueryEnabled, throwOnError, isRedesigned = false }: TProps) => {
    const { user }: TUserState<EUserRole.Coach> = useUser<EUserRole.Coach>()

    const { data } = useCalendarProfiles(isQueryEnabled, throwOnError)

    const onAddCalendarClick = () => {
        window.open(CoachCalendarStep.CALENDAR_ADD)
    }

    return (
        <div className="calendar-accounts">
            <div className="calendar-accounts__header">
                <p className="mb-0 text-center font-extrabold">{user.firstName}&apos;s Calendar Accounts</p>
            </div>
            <div className="calendar-accounts__body">
                {data?.length > 0 ? (
                    data?.map(calendar => <CalendarAccountItem calendar={calendar} isRedesigned={isRedesigned} />)
                ) : (
                    <div className="calendar-accounts__item">
                        <div className="flex-1 text-center font-italic color-gray">No accounts linked yet.</div>
                    </div>
                )}

                <div className="calendar-accounts__footer">
                    <Button
                        isContainer
                        className="p-0 m-0 d-flex align-items-center gap-x-[10px]"
                        onClick={onAddCalendarClick}
                    >
                        <AddIcon fillColor={isRedesigned ? THEME.COLORS.blue[200] : THEME.COLORS.accentOld} />
                        <span
                            className={buildCssClassName({
                                "!text-accentOld": !isRedesigned,
                                "text-blue-200 font-[800]": isRedesigned
                            })}
                        >
                            Add Calendar Account
                        </span>
                    </Button>
                </div>
            </div>
        </div>
    )
}
